/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var CommentKind;
(function (CommentKind) {
    CommentKind[CommentKind["NUMBER_1"] = 1] = "NUMBER_1";
    CommentKind[CommentKind["NUMBER_2"] = 2] = "NUMBER_2";
})(CommentKind || (CommentKind = {}));
export function CommentKindFromJSON(json) {
    return CommentKindFromJSONTyped(json, false);
}
export function CommentKindFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CommentKindToJSON(value) {
    return value;
}
